import React from 'react'

type Props = {
	title: string
	children: React.ReactNode
}

export const FilterOptions = ({ title, children }: Props) => {
	return (
		<div data-testid={`Filter-${title}`} className="text-gray-500 py-6 border-t border-t-gray-1000">
			<h2 className="text-bc-black text-xs font-medium uppercase mb-3">{title}</h2>
			{children}
		</div>
	)
}
